<template>
    <div class="box">
		<el-container>
			<Hander :navTop="divBoxTop"/>
			<el-main class="main container" >
				<template v-for="(item,index) in current_tabs">
					<keep-alive :key="index">
						<component :ref="item.name"  :is="item.content" v-if="current_tab == item.code"></component>
					</keep-alive>
				</template>
			</el-main>
			<Footer />
		</el-container>
    </div>
</template>
<script>
	import { mapState } from 'vuex'
	import Hander from './components/hander.vue'
	import Footer from './components/footer.vue'
    export default {
		components:{
			Hander,
			Footer
		},
        data(){
            return{
				divBoxTop:0
            }
        },
		computed:{
			...mapState({
				current_tab: state => state.app.current_tab,
				current_tabs: state => state.app.current_tabs,
			}),
		},
		mounted(){
			window.addEventListener('scroll', this.handleScroll, true);
		},
        methods:{
			handleScroll(){
				this.divBoxTop = document.documentElement.scrollTop
			}
        },
		watch:{
			
		}
    }
</script>
<style scoped  lang="scss">
	
</style>